import { createSlice } from '@reduxjs/toolkit';

const initialState = { products: {}, status: 'not fullfieled', error: '' };

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    productsHandler(state, action) {
      if (action.payload.error) {
        state.error = action.payload.error;
        state.products = {};
        state.status = 'error';
      } else {
        state.products = action.payload.data ?? action.payload;
        state.error = null;
        state.status = 'fulfilled';
      }
    },
    clearProducts(state) {
      state.products = {};
      state.error = null;
      state.status = 'not fulfilled';
    },
  },
});
export const productsAction = productsSlice.actions;
export default productsSlice;
